import axios from 'axios';
import { BASE_URL } from '../../../../Constants/constants';
import i18n from '../../../../i18n/i18n'; // Import i18n instance for translations

// Helper function to get Authorization Config
const getAuthConfig = () => {
    const token = localStorage.getItem('accessToken');
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};

// Helper function to get translation
const t = (key, options = {}) => {
    return i18n.t(`staffInformation.api.${key}`, options);
};

// Fetch Staff Information Data
export const fetchStaffInformation = async () => {
    try {
        console.log(t('fetchingFrom'), `${BASE_URL}/staff_information/me`);
        const response = await axios.get(`${BASE_URL}/staff_information/me`, getAuthConfig());
        console.log(t('fetchResponse'), response.data);
        return response.data; // Return fetched data
    } catch (error) {
        if (error.response?.status === 404) {
            console.log(t('noRecordFound'));
            return null; // No record found
        }
        console.error(t('errorFetching'), error);
        console.error(t('errorDetails'), error.response?.data || error.message);
        throw new Error(t('failedToFetch'));
    }
};

// Save Staff Information Data
export const saveStaffInformation = async (formData, currentUser) => {
    const sanitizedData = { ...formData, user_id: currentUser.id };

    try {
        console.log(t('makingApiCall'), sanitizedData);
        console.log(t('authConfig'), getAuthConfig());

        let response;
        if (sanitizedData.id) {
            // Update existing staff record
            console.log(t('updatingRecord', {
                id: sanitizedData.id,
                url: `${BASE_URL}/staff_information/${sanitizedData.id}`
            }));
            response = await axios.put(
                `${BASE_URL}/staff_information/${sanitizedData.id}`,
                sanitizedData,
                getAuthConfig()
            );
        } else {
            // Create a new staff record
            console.log(t('creatingRecord', { url: `${BASE_URL}/staff_information` }));
            response = await axios.post(
                `${BASE_URL}/staff_information`,
                sanitizedData,
                getAuthConfig()
            );
        }

        console.log(t('apiResponse'), response);
        return response.data; // Return the updated staff information data
    } catch (error) {
        console.error(t('errorSaving'), error);
        console.error(t('errorConfig'), error.config);
        console.error(t('errorResponse'), error.response);
        console.error(t('errorDetails'), error.response?.data || error.message);
        throw new Error(t('failedToSave', { message: error.response?.data?.message || error.message }));
    }
};

// Delete Staff Information Data
export const deleteStaffInformation = async (staffId) => {
    try {
        const response = await axios.delete(`${BASE_URL}/staff_information/${staffId}`, getAuthConfig());
        return response.data; // Return confirmation response
    } catch (error) {
        console.error(t('errorDeleting'), error);
        throw new Error(t('failedToDelete'));
    }
};